module.exports = __webpack_public_path__ + "static/media/bhupesh_patil.e7d69739.jpeg";